import { createSlice } from '@reduxjs/toolkit';
import { getStaffList, sendLetter } from '../actions/notap';
import { formatErrorResponse } from '../../../helpers/helpers';


const initialState = {
    notapUserLoading: false,
    notapUserErrorMsg: null,
    notapUserSuccessMsg: null,
    staff: [],
    certificateManagement: {
        certificatesData: [],
        newData: false,
        certificateDetails: '',
        previousCertificateDetails: '',
        additionalDocs: [],
        showCertificateForm: false,
        showPrevCertificateDetails: false,
        showStatusChangeConfirmation: false,
        showStatusReConfirm: false,
        showCommentFormNotap: false,
        comments: [],
        newComment: false,
        previousCertificateRequest: {},
        // certificateStatus: '',
        // certificateStatusConfirmationBtnText: '',
        // documentType: 'Certificate'
    },
    userManagement: {
        usersData: []
    },
    searchResult: {
        searchResultData: {},
        newData: false,
        searchResultDetails: '',
        certificateSearchValue: '',
    },
    evaluationManagement:{
        evaluationsData: [],
        evaluationDetails: '',
        newData: false,
        showCommentRichTextForm: false,
        showEvaluationDetails: false,
        showSendEvalForm: false,
        hasBeenSent: false,
        hasAddedEval: false,
        evalStatus: 'draft',
        evalId: null,
        showDocumentCarousel: false,
    },
    digitalLetterManagement: {
        inboxLetters: [],
        draftLetters: [],
        sentLetters: [],
        inboxLetterDetails: '',
        draftLetterDetails: '',
        sentLetterDetails: '',
        activeEmailTab: 'inbox',
        showDeleteConfirmationForm: false,
        showAttachmentModal: false,
        newLetter: false
        // letterStatus: ''
    },
}

export const notapUserSlice = createSlice({
    name: 'notapUserApp',
    initialState,
    reducers: {
        clearAll: (state, action) => {
            state.notapUserLoading = false
            state.notapUserErrorMsg = null
            state.notapUserSuccessMsg = null
        },
        clearOnReload: (state, action) =>{
            state.certificateManagement = {
                ...initialState.certificateManagement,
                certificateDetails: state.certificateManagement.certificateDetails,
                previousCertificateDetails: state.certificateManagement.previousCertificateDetails,
                previousCertificateRequest: state.certificateManagement.previousCertificateRequest
            }
            state.digitalLetterManagement = {
                ...initialState.digitalLetterManagement,
                inboxLetterDetails: state.digitalLetterManagement.inboxLetterDetails,
                sentLetterDetails: state.digitalLetterManagement.sentLetterDetails,
                draftLetterDetails: state.digitalLetterManagement.draftLetterDetails
            }
            state.searchResult = {
                ...initialState.searchResult,
                certificateSearchValue: state.searchResult.certificateSearchValue
            }
        },
        clearResponseMsg: (state, action) => {
            state.notapUserErrorMsg = null
            state.notapUserSuccessMsg = null

        },
        setLoadingNotapUser: (state, action) => {
            state.notapUserLoading = action?.payload?.loading
        },
        clearResetBot: (state) => {
            state.certificateManagement.newData = false
            state.certificateManagement.newComment = false
            state.digitalLetterManagement.newLetter = false
            state.searchResult.newData = false
            state.evaluationManagement.newData = false
        },
        setErrorMessageNotapUser: (state, action) => {
            let msg = action.payload.message
            state.notapUserLoading = false
            state.notapUserErrorMsg = msg
        },
        setSuccessMessageNotapUser: (state, action) => {
            let msg = action.payload.message
            state.notapUserLoading = false
            state.notapUserSuccessMsg = msg
        },
        logoutNotapUser: (state, action) => {
              return initialState
        },
        onGetComments: (state, action) => {
            state.notapUserSuccessMsg = ''
            state.certificateManagement.comments = action.payload
        },
        
        onGetCertificates: (state, action) => {
            state.notapUserSuccessMsg = ''
            state.certificateManagement.certificatesData = action.payload
            state.certificateManagement.newData = true
        },
        onGetInboxLetters: (state, action) => {
            state.notapUserSuccessMsg = ''
            state.digitalLetterManagement.inboxLetters = action.payload
        },
        onGetDraftLetters: (state, action) => {
            state.notapUserSuccessMsg = ''
            state.digitalLetterManagement.draftLetters = action.payload
        },
        onGetSentLetters: (state, action) => {
            state.notapUserSuccessMsg = ''
            state.digitalLetterManagement.sentLetters = action.payload
        },
        onAddComment: (state, action) => {
            // state.certificateManagement.showCommentFormNotap = false
            state.notapUserSuccessMsg = action.payload.message
            // state.certificateManagement.newComment = true
        },
        onSendLetter: (state, action) => {

            state.notapUserSuccessMsg = action.payload.message
        },
        onSearch: (state, action) => {
            state.searchResult.certificateSearchValue = action.payload.searchValue
        } ,
        onDeleteLetter: (state, action) => {
            state.notapUserSuccessMsg = "Letter Deleted Successfully"
            state.digitalLetterManagement.showDeleteConfirmationForm = false
            state.digitalLetterManagement.newLetter = true
        },
         onChangeStatus: (state, action) => {
            state.notapUserSuccessMsg = action.payload.message
            state.certificateManagement.certificateDetails = {...state.certificateManagement.certificateDetails, CERTIFICATE_STATUS: action.payload.status}
            state.certificateManagement.showStatusChangeConfirmation = false
            state.certificateManagement.showStatusReConfirm = false
            state.evaluationManagement.newData = true
        },
        // onShowAttachment: (state, action) => {
        //     state.digitalLetterManagement.showAttachmentModal = false
        // },
        showCommentFormFunc: (state, action) => {
            state.certificateManagement.showCommentFormNotap = action.payload.modal
        },
        showDeleteConfirmationFunc: (state, action) => {
            state.digitalLetterManagement.showDeleteConfirmationForm = action.payload.modal
        },
        showStatusChangeConfirmationFunc: (state, action) => {
            state.certificateManagement.showStatusChangeConfirmation = action.payload.modal
        },
        showStatusReConfirmFunc: (state, action) => {
            state.certificateManagement.showStatusReConfirm = action.payload.modal
        },
        showAttachmentFunc: (state, action) => {
            state.digitalLetterManagement.showAttachmentModal = action.payload.modal
        },
        setSearchResultDetails: (state, action) => {
            state.searchResult.searchResultDetails = action.payload.details
            // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
        },
        setInboxLetterDetails: (state, action) => {
            state.digitalLetterManagement.inboxLetterDetails = action.payload.details
            // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
        },
        setDraftLetterDetails: (state, action) => {
            state.digitalLetterManagement.draftLetterDetails = action.payload.details
            // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
        },
        setSentLetterDetails: (state, action) => {
            state.digitalLetterManagement.sentLetterDetails = action.payload.details
            // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
        },
        onGetSearchResult: (state, action) => {
            state.notapUserSuccessMsg = ''
            // state.searchResult.searchResultData = action.payload
            // state.searchResult.newData = true
        },
        setActiveEmailTab: (state, action) => {
            state.digitalLetterManagement.activeEmailTab = action.payload.name
        },
        onGetUsers: (state, action) => {
            state.userSuccessMsg = ''
            state.userManagement.usersData = action.payload
        },
        onAddCertificateWHTRate: (state, action) => {
            state.certificateManagement.showCertificateForm = false
            state.notapUserErrorMsg = ''
            state.notapUserSuccessMsg = 'WHT Rate Added Successfully'
            state.certificateManagement.newData = true
        },
        setCertificateDetails: (state, action) => {
            state.certificateManagement.certificateDetails = action.payload.details
            state.certificateManagement.previousCertificateDetails = action?.payload?.previous ?? '' 
            // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
        },
        showCertificateFormFunc: (state, action) => {
            state.certificateManagement.showCertificateForm = action.payload.modal
        },
        showCommentRichTextFormFunc: (state, action) => {
            state.evaluationManagement.showCommentRichTextForm = action.payload.modal
             state.evaluationManagement.evalStatus= action.payload.status
             state.evaluationManagement.evalId = action.payload.evalId
        },
        showEvaluationDetailsFunc: (state, action) => {
            state.evaluationManagement.showEvaluationDetails = action.payload.modal
        },
        showPrevCertificateDetailsFunc: (state, action) => {
            state.certificateManagement.showPrevCertificateDetails = action.payload.modal
        },
        showSendEvalFormFunc: (state, action) => {
            state.evaluationManagement.showSendEvalForm = action.payload.modal
             state.evaluationManagement.evalStatus= action.payload.status
             state.evaluationManagement.evalId = action.payload.evalId
        },
        onAddEvaluation: (state, action) => {
            state.evaluationManagement.showCommentRichTextForm = false
            state.notapUserErrorMsg = ''
            state.notapUserSuccessMsg = 'Evaluation Added Successfully'
            state.evaluationManagement.newData = true
            state.evaluationManagement.hasAddedEval = true
        },
        onEvalSent: (state, action) => {
            state.evaluationManagement.showCommentRichTextForm = false
            state.evaluationManagement.showSendEvalForm = false
            state.notapUserErrorMsg = ''
            state.notapUserSuccessMsg = 'Evaluation Sent Successfully'
            state.evaluationManagement.newData = true
            state.evaluationManagement.hasBeenSent = true
        },
        changeHasAddedEval: (state, action) => {
            state.evaluationManagement.hasAddedEval = false
        },
        onGetEvaluations: (state, action) => {
            state.notapUserSuccessMsg = ''
            state.evaluationManagement.evaluationsData = action.payload
            state.evaluationManagement.newData = true
        },
        setEvalDetails: (state, action) => {
            state.evaluationManagement.evaluationDetails = action.payload.details
        },
        showDocumentCarouselFunc: (state, action) => {
            state.evaluationManagement.showDocumentCarousel = action.payload.modal
        },
        onGetAdditionalDocuments: (state, action) => {
            state.notapUserSuccessMsg = ''
            state.certificateManagement.additionalDocs = action.payload
        },
        setPreviousCertificateId: (state, action) => {
            state.certificateManagement.previousCertificateRequest = action.payload
        },
        // setConfirmationStatusModalText: (state, action) =>{
        //     state.certificateManagement.certificateStatus = action.payload.status ?? state.certificateManagement.certificateStatus
        //     state.certificateManagement.certificateStatusConfirmationBtnText = action.payload.btnText ?? state.certificateManagement.certificateStatusConfirmationBtnText
        //     state.certificateManagement.documentType = action.payload.documentType ??  state.certificateManagement.documentType
        // }
    },
    extraReducers: (builder) => {
        builder.addCase(getStaffList.pending, (state) => {
            state.notapUserLoading = true
        })
        .addCase(getStaffList.fulfilled, (state, action) => {
            state.notapUserLoading = false;
            state.staff = action.payload.data;
        })
        .addCase(getStaffList.rejected, (state, action) => {
            state.notapUserLoading = false

            if (action.payload) state.notapUserErrorMsg = formatErrorResponse(action.payload);
            else state.notapUserErrorMsg = action.error.message;
        });
        builder.addCase(sendLetter.pending, (state) => {
            state.notapUserLoading = true
        })
        .addCase(sendLetter.fulfilled, (state, action) => {
            state.notapUserLoading = false;
        })
        .addCase(sendLetter.rejected, (state, action) => {
            state.notapUserLoading = false

            if (action.payload) state.notapUserErrorMsg = formatErrorResponse(action.payload);
            else state.notapUserErrorMsg = action.error.message;
        });
    }
});

// Action creators are generated for each case reducer function
export const {
    clearAll,
    clearResetBot,
    setErrorMessageNotapUser,
    setLoadingNotapUser,
    setSuccessMessageNotapUser,
    onGetCertificates,
    setCertificateDetails,
    onGetComments,
    onChangeStatus,
    onGetSearchResult,
    showCertificateFormFunc,
    showCommentFormFunc,
    showDeleteConfirmationFunc,
    setEvalDetails,
    showStatusChangeConfirmationFunc,
    showStatusReConfirmFunc,
    onAddCertificateWHTRate,
    onAddComment,
    onDeleteLetter,
    onGetInboxLetters,
    onGetDraftLetters,
    onGetSentLetters,
    clearResponseMsg,
    clearOnReload,
    logoutNotapUser,
    setInboxLetterDetail,
    setActiveEmailTab,
    onSendLetter,
    onGetUsers,
    setInboxLetterDetails,
    setDraftLetterDetails,
    setSentLetterDetails,
    showAttachmentFunc,
    onSearch,
    setSearchResultDetails,
    setConfirmationStatusModalText,
    showCommentRichTextFormFunc,
    showEvaluationDetailsFunc,
    showPrevCertificateDetailsFunc,
    showSendEvalFormFunc,
    onAddEvaluation,
    onGetEvaluations,
    onEvalSent,
    showDocumentCarouselFunc,
    changeHasAddedEval,
    onGetAdditionalDocuments,
    setPreviousCertificateId
} = notapUserSlice.actions

export default notapUserSlice.reducer